import { useEffect, useState } from 'react'
import classNames from 'classnames'

import { ReactComponent as EllipsisIcon } from '@/assets/icons/ellipsis-icon.svg'
import { ReactComponent as BoxesIcon } from '@/assets/icons/boxes-icon.svg'

import { EditDropdownMenu } from '@/components/SideMenu/components/HomeMenu/components/BoxesButtons/EditDropdownMenu/EditDropdownMenu'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import boxesService from '@/app-domains/boxes/boxes.service'

import './BoxesButtons.scoped.sass'

function BoxButton ({ box, selectBox, selectedBox, selectedBoxes }) {
  const [menuOpened, setMenuOpened] = useState(false)
  const [menuOpenedEvent, setMenuOpenedEvent] = useState(false)
  const [isMarked, setIsMarked] = useState(false)
  
  const toggleMenuOpen = (e) => {
    e.stopPropagation()
    if (dropdownService.isOpenedForThisTarget(e)) {
      setMenuOpened(false)
      setMenuOpenedEvent(false)
      return dropdownService.close()
    }
    
    setMenuOpenedEvent(e)
    setMenuOpened(Date.now())
  }

  useRenderEvent([`${box.id}:UNMARKED`], () => {
    setIsMarked(false)
  })

  useRenderEvent(['DROPDOWN:CLOSE'], () => {
    setMenuOpened(false)
    setMenuOpenedEvent(false)
  })

  return <>
    <li id={'label-button' + box.id} className={classNames({ active: selectedBox === box.id, 'menu-opened': menuOpened })} onClick={() => selectBox(box)}>
      <div className="label-left">
        <span className='label-icon'>
          <BoxesIcon />
        </span>
        <span className='label-name' title={box.boxalias || box.boxname}>
          {box.boxalias || box.boxname}
        </span>
      </div>
      <div className='label-button-right-menu-boxes'>
        <div className="label-right">
          {box.msgunopen}
        </div>
        <div className='mark-box'>
          <input type='checkbox' checked={isMarked} onClick={(e) => {
            e.stopPropagation()
            setIsMarked(!isMarked)
            const boxArr = [box]
            if (isMarked === false) {
              const newArr = selectedBoxes.concat(boxArr)
              boxesService.saveSelectedBoxes(newArr)
            } else {
              const filteredArr = selectedBoxes.filter((selectedBox) => selectedBox.id !== box.id)
              boxesService.saveSelectedBoxes(filteredArr)
            }
          }
          }/>
        </div>
        <div className="label-button-dropdown-button" onClick={toggleMenuOpen}>
          <EllipsisIcon />
          {menuOpened && <EditDropdownMenu box={box} event={menuOpenedEvent} />}
        </div>
      </div>
    </li>
  </>
}

export function BoxesButtons ({ selectBox, selectedBox, currentBoxes, selectedLabel, selectLabel, selectedSortType }) {
  const [boxes, setBoxes] = useState(boxesService.getAllStoredBoxes().filter(box => !box.archived))
  const [selectedBoxes, setSelectedBoxes] = useState(boxesService.getSelectedBoxesFromStore() || [])
  useRenderEvent(['CONTAINERS:UPDATED', 'LABELS:UPDATED', 'LABELS:DELETED'], () => {
    setBoxes(boxesService.getAllStoredBoxes().filter(box => !box.archived))
  })

  useRenderEvent(['SELECTED_BOXES:UPDATED'], () => {
    setSelectedBoxes(boxesService.getSelectedBoxesFromStore)
  })
  const sorts = {
    none: () => {},
    'A-Z': (a, b) => a.boxname.localeCompare(b.boxname),
    Unread: (a, b) => b.msgtotal - a.msgtotal,
    'Created at': (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    'Updated at': (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  }
  useEffect(() => {
    const [firstBox] = boxes
      .sort(sorts[selectedSortType] || sorts.none)
    selectBox(firstBox)
  }, [])

  return boxes
    .sort(sorts[selectedSortType] || sorts.none)
    .map((box) => {
      return <BoxButton key={box.id} box={box} selectedBoxes={selectedBoxes} setSelectedBoxes={setSelectedBoxes}
      selectedLabel={selectedLabel} selectLabel={selectLabel} currentBoxes={currentBoxes}
      selectBox={selectBox} selectedBox={selectedBox}
      />
    })
}
